module.exports = __webpack_public_path__ + "34cb01b7e4863b0c2ab0790e8f468661.svg";